<ng-container *ngIf="item" [ngSwitch]="item.widget">
  <ng-container *ngSwitchDefault>
    <div d-component [is]="getComponent(item.widget)" [data]="item"> </div>
  </ng-container>
</ng-container>
